import { Refresh } from 'assets/Icons'
import { Tooltip } from 'components/Overlay'
import { any, array, bool, func, string } from 'prop-types'
import { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import ReactSelect, { components } from 'react-select'
import styled from 'styled-components'
const StyledClearIndicator = styled.div`
	align-items: center;
	cursor: pointer;
	display: flex;
	height: 23px;
	justify-content: center;
	width: 23px;
`
const StyledOption = styled.div`
	& .valid-date {
		display: flex;
		align-items: center;
		& .invalid {
			background-color: var(--danger);
			border-radius: 10px;
			color: var(--white);
			padding: 2px 10px;
			margin: 0 0 0 4px;
		}
	}
`
const ClearIndicator = props => (
	<StyledClearIndicator onClick={props.clearValue}>
		<svg fill='none' height='16' viewBox='0 0 16 16' width='16'>
			<path
				d='M12 4L4 12'
				stroke='#949494'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='2'
			/>
			<path
				d='M4 4L12 12'
				stroke='#949494'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='2'
			/>
		</svg>
	</StyledClearIndicator>
)
const Input = props => (
	<components.Input {...props} data-cy={props?.selectProps?.['data-cy']} />
)
const Control = props => (
	<components.Control
		{...props}
		innerProps={Object.assign(
			{},
			props?.innerProps,
			props?.selectProps?.isSearchable
				? {}
				: { 'data-cy': props?.selectProps?.['data-cy'] }
		)}
	/>
)
const Option = props => {
	const { t } = useTranslation('components')
	// const PINFL = props?.data?.certificate?.PINFL;
	// const TIN = props?.data?.certificate?.TIN;
	const CN = props?.data?.certificate?.CN
	const name = props?.data?.certificate?.name
	const serialNumber = props?.data?.certificate?.serialNumber
	// const isBusiness = useMemo(() => {
	//    const TIN = !!props?.data?.certificate?.TIN;
	//    const O = !!props?.data?.certificate?.O;
	//    const isBusiness = O && TIN;
	//    return isBusiness;
	// }, [props]);
	const validDate = useMemo(() => {
		const validDate = new Date(props?.data?.certificate?.validTo)
			.toISOString()
			.slice(0, 10)
			.split('-')
			.reverse()
			.join('.')
		return validDate
	}, [props])
	return (
		<components.Option
			{...props}
			innerProps={Object.assign({}, props?.innerProps, {
				'data-cy': props?.selectProps?.['data-cy'] + '-' + props?.value,
			})}
		>
			<StyledOption>
				{CN ? (
					<div>
						{t('Ф.И.О')}: {CN}
					</div>
				) : (
					''
				)}
				<div>
					№ {t('СЕРТИФИКАТА')}: {serialNumber}{' '}
				</div>
				{name ? (
					<div>
						{t('Файл')}: {name}
					</div>
				) : (
					''
				)}
				{/* {isBusiness ? <div>ИНН: {TIN}</div> : <div>ПИНФЛ: {PINFL}</div>} */}
				<div className='valid-date'>
					{t('Срок действия')}: {validDate}{' '}
					{props?.isDisabled ? <div className='invalid'>Истек</div> : ''}
				</div>
			</StyledOption>
		</components.Option>
	)
}
const defaultOptions = {
	className: 'e-imzo-select-input',
	isMulti: false,
	maxMenuHeight: 300,
	menuPlacement: 'auto',
	menuPortalTarget: document.body,
	components: {
		ClearIndicator,
		Control,
		IndicatorSeparator: () => null,
		Input,
		Option,
	},
}
const styles = {
	valueContainer: styles => ({
		...styles,
		display: 'flex',
		height: 46,
		padding: '11px 0 11px 15px',
	}),
	singleValue: (styles, { isDisabled }) => ({
		...styles,
		color: isDisabled ? '#717171' : '#000000',
		fontSize: 16,
		fontWeight: 500,
		left: 0,
		margin: 0,
		padding: '12px 0 12px 16px',
		position: 'absolute',
		top: 0,
		'.dark &': {
			color: isDisabled ? '#aaaaaa' : '#e1e1e1',
		},
	}),
	placeholder: styles => ({
		...styles,
		fontSize: 16,
		fontWeight: 500,
		margin: 0,
		position: 'absolute',
		left: 0,
		top: '1.8px',
		padding: '10px 8px 10px 16px',
		color: '#717171',
		'.dark &': {
			color: '#e1e1e1',
		},
	}),
	input: (styles, { isDisabled }) => ({
		...styles,
		color: isDisabled ? '#717171' : '#000000',
		fontSize: 16,
		fontWeight: 500,
		left: 14,
		position: 'absolute',
		top: 7,
		'.dark &': {
			color: isDisabled ? '#aaaaaa' : '#e1e1e1',
		},
	}),
	indicatorsContainer: styles => ({ ...styles, padding: '0 12px 0 8px' }),
	dropdownIndicator: styles => ({
		...styles,
		alignItems: 'center',
		backgroundColor: 'transparent',
		borderRadius: 12,
		color: '#808080',
		display: 'flex',
		height: 23,
		justifyContent: 'center',
		margin: 0,
		padding: 0,
		width: 23,
		':hover': {
			color: '#808080',
		},
		svg: {
			width: 18,
		},
		'.dark &': {
			color: '#aaaaaa',
			':hover': {
				color: '#aaaaaa',
			},
		},
	}),
	menuPortal: styles => ({ ...styles, zIndex: 9999 }),
	menu: styles => ({
		...styles,
		backgroundColor: '#ffffff',
		border: 'none',
		borderRadius: 12,
		boxShadow:
			'0 1px 20px 0 rgba(13, 46, 105, 0.07), 0 1px 20px 0 rgba(13, 46, 105, 0.07)',
		margin: 0,
		overflow: 'hidden',
		padding: 0,
		'.dark &': {
			backgroundColor: '#333333',
			boxShadow:
				'0 1px 20px 0px rgba(0, 0, 0, 0.07), 0 1px 20px 0px rgba(0, 0, 0, 0.07)',
		},
	}),
	noOptionsMessage: styles => ({
		...styles,
		color: '#000000',
		cursor: 'default',
		fontSize: 16,
		fontWeight: 500,
		height: 44,
		padding: 12,
		textAlign: 'left',
		width: '100%',
		'.dark &': {
			color: '#e1e1e1',
		},
	}),
	menuList: styles => ({
		...styles,
		padding: 8,
		'::-webkit-scrollbar': {
			padding: '0 5px 0 0',
			width: 6,
		},
		'::-webkit-scrollbar-track': {
			backgroundColor: 'transparent',
		},
		'::-webkit-scrollbar-thumb': {
			backgroundColor: 'var(--main)',
			borderRadius: 4,
		},
	}),
	option: (styles, { isSelected, isDisabled, isFocused }) => ({
		...styles,
		backgroundColor: isDisabled
			? '#f7f8fc'
			: isSelected
			? 'var(--main)'
			: isFocused
			? 'var(--success-20)'
			: '#ffffff',
		borderRadius: 10,
		color: isDisabled
			? '#696f85'
			: isSelected
			? '#ffffff'
			: isFocused
			? '#000000'
			: '#000000',
		cursor: isDisabled ? 'not-allowed' : 'pointer',
		fontSize: 16,
		fontWeight: 500,
		overflow: 'hidden',
		padding: 12,
		textOverflow: 'ellipsis',
		transition: 200,
		whiteSpace: 'nowrap',
		width: '100%',
		':hover': {
			backgroundColor: isDisabled
				? '#f7f8fc'
				: isSelected
				? 'var(--main)'
				: 'var(--success-20)',
		},
		'.dark &': {
			color: '#ffffff',
			backgroundColor: isDisabled
				? '#333333'
				: isSelected
				? '#018ECC'
				: isFocused
				? '#41932133'
				: 'transparent',
			':hover': {
				backgroundColor: isDisabled
					? '#333333'
					: isSelected
					? '#018ECC'
					: '#41932133',
			},
		},
	}),
}
const EImzoSelect = memo(
	({
		'data-cy': dataCY,
		certificates = [],
		getCertificates,
		hideBorder = false,
		isClearable = true,
		isDisabled = false,
		isError = false,
		isSearchable = true,
		noOptionsMessage = null,
		onChange,
		onFocus,
		placeholder = '',
		value = null,
	}) => {
		const { t } = useTranslation('components')
		const NoOptionsMessage = useMemo(() => {
			const NoOptionsMessage = noOptionsMessage
				? noOptionsMessage
				: () => t('not-found')
			return NoOptionsMessage
		}, [noOptionsMessage, t])
		return (
			<div className='w-full flex items-center gap-3'>
				<div className='w-[calc(100%-46px)]'>
					<ReactSelect
						{...defaultOptions}
						data-cy={dataCY}
						isClearable={isClearable}
						isDisabled={isDisabled}
						isSearchable={isSearchable}
						noOptionsMessage={NoOptionsMessage}
						onChange={onChange}
						onFocus={onFocus}
						placeholder={placeholder}
						value={value}
						options={certificates}
						styles={{
							...styles,
							control: (styles, { isFocused, isDisabled }) => ({
								...styles,
								backgroundColor: isDisabled ? '#f4f4f4' : '#ffffff',
								borderRadius: 10,
								borderStyle: 'solid',
								borderWidth: hideBorder ? 0 : 1.5,
								boxShadow: 'none',
								color: '#000000',
								height: 48,
								minHeight: 48,
								minWidth: 100,
								outline: 'none',
								padding: 0,
								transition: 0,
								width: '100%',
								cursor: isDisabled
									? 'default'
									: isSearchable
									? 'text'
									: 'pointer',
								borderColor: isFocused
									? '#018ECC'
									: isError
									? '#e41d32'
									: '#e1e1e1',
								':hover': { borderColor: '#018ECC' },
								'.dark &': {
									backgroundColor: '#2E2D2D',
									color: '#e1e1e1',
									borderColor: isFocused
										? '#018ECC'
										: isError
										? '#e41d32'
										: '#555555',
									':hover': { borderColor: '#018ECC' },
								},
							}),
						}}
					/>
				</div>
				<Tooltip title={t('Обновить список сертификатов')} distance={8}>
					<div onClick={getCertificates} className='clear-btn'>
						<Refresh />
					</div>
				</Tooltip>
			</div>
		)
	}
)
EImzoSelect.propTypes = {
	'data-cy': string,
	certificates: array,
	getCertificates: func,
	hideBorder: bool,
	isClearable: bool,
	isDisabled: bool,
	isError: bool,
	isSearchable: bool,
	noOptionsMessage: any,
	onChange: func,
	onFocus: func,
	options: array,
	placeholder: string,
	value: any,
}
export default EImzoSelect
